// extracted by mini-css-extract-plugin
export var avatarContainer = "_7u-0";
export var avatarTypingWave = "_7u-i";
export var gray = "_7u-f";
export var green = "_7u-c";
export var icon = "_7u-9";
export var image = "_7u-1";
export var lg = "_7u-6";
export var md = "_7u-5";
export var presenceDot = "_7u-b";
export var red = "_7u-d";
export var sm = "_7u-4";
export var status = "_7u-a";
export var typingDot = "_7u-h";
export var typingPill = "_7u-g";
export var xl = "_7u-7";
export var xs = "_7u-3";
export var xxl = "_7u-8";
export var xxs = "_7u-2";
export var yellow = "_7u-e";